(function () {
  var TAB_SELECTOR = '[data-variant-tab]'
  var PANEL_SELECTOR = '[data-variant-tab-category]'
  var HIDDEN_CLASS = 'hide'
  var ACTIVE_CLASS = 'active'

  function initContainer(container) {
    var tabs = [].slice.call(container.querySelectorAll(TAB_SELECTOR))
    var panels = [].slice.call(container.querySelectorAll(PANEL_SELECTOR))

    if (tabs.length === 0) return

    function setActiveTab(activeTab) {
      var tabValue = activeTab.getAttribute('data-variant-tab')

      tabs.forEach(function (tab) {
        var isSelected = tab === activeTab
        tab.classList.toggle(ACTIVE_CLASS, isSelected)
        tab.setAttribute('aria-selected', String(isSelected))
      })

      if (tabValue === 'all') {
        container.classList.add('is-all-active')
        panels.forEach(function (panel) {
          panel.classList.remove(HIDDEN_CLASS)
        })
      } else {
        container.classList.remove('is-all-active')
        panels.forEach(function (panel) {
          var category = panel.getAttribute('data-variant-tab-category')
          var shouldShow = category === tabValue
          panel.classList.toggle(HIDDEN_CLASS, !shouldShow)
        })
      }
    }

    container.addEventListener('click', function (e) {
      var tab = e.target.closest(TAB_SELECTOR)
      if (tab && container.contains(tab)) {
        e.preventDefault()
        setActiveTab(tab)
      }
    })

    var activeTab = container.querySelector(TAB_SELECTOR + '[aria-selected="true"]') || tabs[0]
    if (activeTab) setActiveTab(activeTab)

    container.addEventListener('keydown', function (e) {
      var tab = e.target.closest(TAB_SELECTOR)
      if (!tab || !container.contains(tab)) return

      var currentIndex = tabs.indexOf(tab)
      var targetIndex = currentIndex

      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault()
          targetIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1
          break
        case 'ArrowRight':
          e.preventDefault()
          targetIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0
          break
        case 'Home':
          e.preventDefault()
          targetIndex = 0
          break
        case 'End':
          e.preventDefault()
          targetIndex = tabs.length - 1
          break
        default:
          return
      }

      var targetTab = tabs[targetIndex]
      if (targetIndex !== currentIndex && targetTab) {
        setActiveTab(targetTab)
        targetTab.focus()
      }
    })
  }

  function init() {
    var containers = document.querySelectorAll('[data-product-variant-tabs]')
    containers.forEach(initContainer)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
